var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditUpload = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.38871C11.5085 2.21361 11.7163 2.07472 11.9451 1.97996C12.1739 1.8852 12.4191 1.83643 12.6667 1.83643C12.9143 1.83643 13.1595 1.8852 13.3883 1.97996C13.6171 2.07472 13.8249 2.21361 14 2.38871C14.1751 2.56381 14.314 2.77168 14.4088 3.00045C14.5036 3.22922 14.5523 3.47442 14.5523 3.72204C14.5523 3.96967 14.5036 4.21486 14.4088 4.44364C14.314 4.67241 14.1751 4.88028 14 5.05538L5.00004 14.0554L1.33337 15.0554L2.33337 11.3887L11.3334 2.38871Z",
    stroke: "#03606A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-upload.76de6464.svg";
export { ForwardRef as ReactComponent };